/**
 * @generated SignedSource<<faf5545fd99f6f48f7e5f9f7bdd62252>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutReviewStep_buyer$data = {
  readonly addressBook: {
    readonly addressList: ReadonlyArray<{
      readonly serviceId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"CheckoutAddressView_address">;
    } | null> | null;
  } | null;
  readonly isTrade: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryOptions_buyer" | "CheckoutMobileSummaryNewPane_buyer" | "CheckoutPaymentView_buyer" | "CheckoutReviewStepDetailsContainer_buyer" | "CheckoutSubmitButton_buyer">;
  readonly " $fragmentType": "CheckoutReviewStep_buyer";
};
export type CheckoutReviewStep_buyer$key = {
  readonly " $data"?: CheckoutReviewStep_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutReviewStep_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutReviewStep_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSubmitButton_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutPaymentView_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutReviewStepDetailsContainer_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileSummaryNewPane_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryOptions_buyer"
    },
    {
      "alias": "isTrade",
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AddressBook",
      "kind": "LinkedField",
      "name": "addressBook",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "addressList",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CheckoutAddressView_address"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "c1d5e82afc15873d0ea29918e9f71077";

export default node;
